import { graphqlClient } from "../../../client";
import mutationDocument from "./createOrderFromCartWithPaymentAuthorizationMutation.graphql";
import type {
  CreateOrderFromCartWithPaymentAuthorizationMutation,
  KeyValueType,
  MutationsCreateOrderFromCartWithPaymentAuthorizationArgs,
} from "@/core/api/graphql/types";

export async function createOrderFromCartWithPaymentAuthorization(
  cartId?: string,
  parameters?: KeyValueType[],
): Promise<CreateOrderFromCartWithPaymentAuthorizationMutation["createOrderFromCartWithPaymentAuthorization"]> {
  const { data } = await graphqlClient.mutate<
    CreateOrderFromCartWithPaymentAuthorizationMutation,
    MutationsCreateOrderFromCartWithPaymentAuthorizationArgs
  >({
    mutation: mutationDocument,
    variables: {
      command: {
        id: cartId,
        parameters,
        storefrontUrl: location.origin,
      },
    },
  });

  return data?.createOrderFromCartWithPaymentAuthorization;
}
